import { Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import { useAuth } from '../contexts/AuthContext';
import { MainLayout } from './components/MainLayout';
import { HOME_PATH_BY_ROLE, resolveRoleFromUser } from './rolePaths';
import { AdminDashboard } from './pages/admin/AdminDashboard';
import { ModeratorsPage } from './pages/admin/ModeratorsPage';
import { SettingsPage } from './pages/admin/SettingsPage';
// import { AIManagerPage } from './pages/admin/AIManagerPage';
// import { MailManagerPage } from './pages/admin/MailManagerPage';
// import { WebsiteScraperPage } from './pages/admin/WebsiteScraperPage';
import { ModeratorDashboard } from './pages/moderator/ModeratorDashboard';
import { ScraperPoolPage } from './pages/moderator/ScraperPoolPage';
import { CollectedRawPage } from './pages/moderator/CollectedRawPage';
import { ArticleAnalysisPage } from './pages/moderator/ArticleAnalysisPage';
import { DocumentPreviewPage } from './pages/moderator/DocumentPreviewPage';
import { DataroomSettingPage } from './pages/moderator/DataroomSettingPage';
import { SubscribersPage } from './pages/moderator/SubscribersPage';
import { EmailTemplatesPage } from './pages/moderator/EmailTemplatesPage';
import { SubscriberDetailPage } from './pages/moderator/SubscriberDetailPage';
import { DraftsOutboxPage } from './pages/moderator/DraftsOutboxPage';
import { DeliveryHistoryPage } from './pages/moderator/DeliveryHistoryPage';
import { CampaignsPage } from './pages/moderator/CampaignsPage';
import { LinkedInScheduledPage } from './pages/moderator/LinkedInScheduledPage';
import { SubscriberNewslettersPage } from './pages/subscriber/SubscriberNewslettersPage';

/** Hawk: role-based routing. Admin = oversight, Moderator = pipeline operator, Subscriber = read-only email recipient. */
export default function MakeApp() {
  const { user } = useAuth();
  const currentRole = resolveRoleFromUser(user);
  const homePath = HOME_PATH_BY_ROLE[currentRole];

  return (
    <>
      <Toaster position="top-right" richColors />
      <Routes>
        <Route path="/" element={<MainLayout currentRole={currentRole} />}>
          <Route index element={<Navigate to={homePath} replace />} />

          {/* Admin */}
          <Route path="dashboard" element={<AdminDashboard />} />
          <Route path="moderators" element={<ModeratorsPage />} />
          <Route path="settings" element={<SettingsPage />} />
          {/* <Route path="ai-manager" element={<AIManagerPage />} /> */}
          {/* <Route path="mail-manager" element={<MailManagerPage />} />
          <Route path="website-scraper" element={<WebsiteScraperPage />} /> */}

          {/* Moderator */}
          <Route path="editorial" element={<ModeratorDashboard />} />
          <Route path="scraper-pool" element={<ScraperPoolPage />} />
          <Route path="collected-raw" element={<CollectedRawPage />} />
          <Route path="article-analysis/:id" element={<ArticleAnalysisPage />} />
          <Route path="article-analysis" element={<ArticleAnalysisPage />} />
          <Route path="document-preview/:documentId" element={<DocumentPreviewPage />} />
          <Route path="dataroom-setting" element={<DataroomSettingPage />} />
          <Route path="subscribers" element={<SubscribersPage />} />
          <Route path="subscribers/:id" element={<SubscriberDetailPage />} />
          <Route path="templates" element={<EmailTemplatesPage />} />
          <Route path="outbox" element={<DraftsOutboxPage />} />
          <Route path="delivery-history" element={<DeliveryHistoryPage />} />
          <Route path="linkedin" element={<CampaignsPage />} />
          <Route path="linkedin-scheduled" element={<LinkedInScheduledPage />} />

          {/* Subscriber */}
          <Route path="newsletters" element={<SubscriberNewslettersPage />} />
        </Route>
      </Routes>
    </>
  );
}
